export const SearchServiceQueryKeys = {
    all: ['search'] as const,
    searchResults: () => [...SearchServiceQueryKeys.all, 'results'] as const,
    tags: () => [...SearchServiceQueryKeys.all, 'tags'] as const,
    tagsByUrls: (urls: string[]) => [...SearchServiceQueryKeys.tags(), 'byUrls', urls] as const,
    tagsByString: (text: string) => [...SearchServiceQueryKeys.tags(), 'byString', text] as const,
    objects: () => [...SearchServiceQueryKeys.all, 'objects'] as const,
    stages: () => [...SearchServiceQueryKeys.all, 'stages'] as const,
    stageCounties: (siteId: string) => [...SearchServiceQueryKeys.stages(), 'counties', siteId] as const,
    parkingSpaces: () => [...SearchServiceQueryKeys.all, 'parkingSpaces'] as const,
};

export const SearchServiceEndpoints = {
    searchObject: 'residence/search_object',
    searchStageAndArea: 'residence/stage_and_area_search',
    searchStage: 'residence/search_stage',
    searchTags: 'residence/search/tags',
    searchTagsByUrl: 'residence/search/tags/url',
    searchStageCounties: 'residence/search_stage_counties',
    searchByIdsStage: 'residence/search/by_ids/stage',
    searchByIdsObject: 'residence/search/by_ids/object',
    stageTags: (siteId: string) => `residence/search/stage_tags/${siteId}`,
    stageTagsByType: (siteId: string, TagDesign: string) => `residence/search/stage_tags/${siteId}/${TagDesign}`,
};
